<template>
    <section id="contact" class="px-12 lg:px-32 py-16 relative max-width-container">
        <h1 class="uppercase text-3xl mb-8 font-semibold text-center lg:text-left">Kapcsolat</h1>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div class="space-y-6">
                <!-- Contact details -->
                <div class="flex items-center">
                    <i class="fa-solid fa-location-dot text-green-500 w-6"></i>
                    <p class="text-stone-500 ml-4">
                        <strong>Cím: </strong>
                        <span class="text-green-500 font-semibold">
                            3792 Sajóbábony, Kossuth út 53.
                        </span>
                    </p>
                </div>
                <div class="flex items-center">
                    <i class="fa-solid fa-envelope text-green-500 w-6"></i>
                    <p class="text-stone-500 ml-4">
                        <strong>E-mail: </strong>
                        <span v-if="!emailVisible" class="text-green-500 font-semibold cursor-pointer" @click="revealEmail">
                            Kattintson a megtekintéshez
                        </span>
                        <a v-else class="text-green-500 font-semibold" :href="`mailto:${email}`">
                            {{ email }}
                        </a>
                    </p>
                </div>
                <div class="flex items-center">
                    <i class="fa-solid fa-phone text-green-500 w-6"></i>
                    <p class="text-stone-500 ml-4">
                        <strong>Telefon: </strong>
                        <span v-if="!phoneVisible" class="text-green-500 font-semibold cursor-pointer" @click="revealPhone">
                            Kattintson a megtekintéshez
                        </span>
                        <a v-else class="text-green-500 font-semibold" :href="`tel:${phone}`">
                            {{ phone }}
                        </a>
                    </p>
                </div>
            </div>
        </div>

        <div class="mt-12">
            <iframe class="w-full h-96 border-0"
                src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJfzGkv_ZhP0cRJfMvkgOptM0&key=AIzaSyD2C-DxhjOiMCmVMsYB8JJK2i1fCgU07yc&maptype=satellite&zoom=13"
                allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
            </iframe>
        </div>

        <div class="mt-12">
            <h2 class="uppercase text-2xl mb-6 font-semibold text-center lg:text-left">Támogatóink</h2>
            <div class="flex justify-center items-center gap-8">
                <a href="https://ataraxia.hu" target="_blank" rel="noopener noreferrer" class="block text-center">
                    <img
                        :src="ataraxiaLogo"
                        alt="Ataraxia"
                        class="h-16 w-auto mx-auto"
                        @error="ataraxiaMissing = true"
                        v-show="!ataraxiaMissing"
                    />
                    <span v-if="ataraxiaMissing" class="text-green-600 font-semibold">Ataraxia</span>
                </a>

                <a href="https://expodom.hu" target="_blank" rel="noopener noreferrer" class="block text-center">
                    <img
                        :src="expodomLogo"
                        alt="Expodom"
                        class="h-10 w-auto mx-auto"
                        @error="expodomMissing = true"
                        v-show="!expodomMissing"
                    />
                    <span v-if="expodomMissing" class="text-green-600 font-semibold">Expodom</span>
                </a>
            </div>
        </div>

        <!-- Contact form -->
        <!-- <div class="space-y-8">
            <form @submit.prevent="submitForm" class="flex flex-col w-full items-center">
                <p class="text-stone-500 text-center w-full lg:w-9/12 font-semibold mb-6">
                    Írjon nekünk, kérjen árajánlatot most!
                </p>
                <label for="user_name" class="text-stone-500 text-left w-full">Név</label>
                <input v-model="form.name" type="text" id="user_name" class="bg-stone-200 py-2 px-4 w-full mb-6"
                    required />

                <label for="user_email" class="text-stone-500 text-left w-full">E-mail cím</label>
                <input v-model="form.email" type="email" id="user_email" class="bg-stone-200 py-2 px-4 w-full mb-6"
                    required />

                <label for="user_phone" class="text-stone-500 text-left w-full">Telefon</label>
                <input v-model="form.phone" type="tel" id="user_phone" class="bg-stone-200 py-2 px-4 w-full mb-6"
                    required />

                <label for="user_message" class="text-stone-500 text-left w-full">Üzenet</label>
                <textarea v-model="form.message" id="user_message" cols="30" rows="5"
                    class="bg-stone-200 py-2 px-4 w-full mb-6" required></textarea>

                <button class="btn bg-green hover:bg-green-dark text-white w-full lg:w-1/2">Küldés</button>
            </form>
        </div> -->
    </section>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            form: {
                name: "",
                email: "",
                phone: "",
                message: "",
            },
            email: "info@mozgasbanmaradok.hu",
            phone: "+36 30 279 7768",
            emailVisible: false,
            phoneVisible: false,
            // Require the actual sponsor images so webpack copies them into dist/img during build
            ataraxiaLogo: require('@/assets/images/sponsors/ataraxia.webp'),
            expodomLogo: require('@/assets/images/sponsors/expodom.webp'),
            ataraxiaMissing: false,
            expodomMissing: false,
        };
    },
    mounted() {
        setTimeout(() => {
            this.emailVisible = true;
            this.phoneVisible = true;
        }, 2000);
    },
    methods: {
        revealEmail() {
            this.emailVisible = true;
        },
        revealPhone() {
            this.phoneVisible = true;
        },
        async submitForm() {
            try {
                await axios.post("http://localhost:3000/api/contact", this.form); // A response változó eltávolítva
                alert("Az üzenet sikeresen elküldve!");
            } catch (error) {
                console.error("Hiba történt az üzenet küldése során:", error);
                alert("Hiba történt az üzenet küldése során.");
            }
        }
    },
};
</script>